function waitForDeps(callback) {
  if (window.pako?.ungzip && window.jQuery && $.fn.DataTable) {
    callback();
  } else {
    setTimeout(() => waitForDeps(callback), 50);
  }
} 
function waitForDataTables(callback) {
  if ($.fn.DataTable) {
    callback();
  } else {
    setTimeout(() => waitForDataTables(callback), 50);
  }
} 
const handlize = (str) =>
  str
    .toLowerCase()
    .trim()
    .replace(/['"`]/g, '') // remove apostrophes & quotes
    .replace(/[^a-z0-9]+/g, '-') // replace spaces/punctuation with dash
    .replace(/^-+|-+$/g, ''); // trim leading/trailing dashes

// Uncompress GZIP FILE
async function fetchGzippedJson(url) {
  const res = await fetch(url);
  const arrayBuffer = await res.arrayBuffer();
  const uint8 = new Uint8Array(arrayBuffer);
  const decompressed = window.pako.ungzip(uint8, { to: 'string' });
  const json = JSON.parse(decompressed);
  return json;
}

async function storeProductsInIndexedDB(jsonData) {
 // console.log('Opening IndexedDB for storage...');
  const db = await openDB();
  
  const tx = db.transaction('products', 'readwrite');
  const store = tx.objectStore('products');

  // ✅ Store the version alongside the products data
  store.put({ id: 'version', version: jsonData.version }); // ✅ Ensures version is in the same object store

  jsonData.products.forEach(product => {
    if (!product.id) {
      console.warn('⚠️ Missing ID, generating fallback:', product);
      product.id = crypto.randomUUID(); // ✅ Generate unique ID if missing
    }
    store.put(product);
  });

  await tx.done;
 // console.log('✅ Products & version successfully stored in IndexedDB');
}



async function debugIndexedDB() {
  const db = await openDB();
  const tx = db.transaction('products', 'readonly');
  const store = tx.objectStore('products');

  const allProducts = await store.getAll();
}

debugIndexedDB();

// Retrieve Cached Data
async function getCachedProducts() {
 // console.log('Opening IndexedDB...');
  const db = await openDB();
 // console.log('DB opened:', db);

  return new Promise((resolve, reject) => {
    const tx = db.transaction('products', 'readonly');
    const store = tx.objectStore('products');

  //  console.log('Fetching all products...');
    const request = store.getAll();

    request.onsuccess = () => {
    //  console.log('✅ Retrieved from IndexedDB:', request.result);
      resolve(request.result); // ✅ Ensures the promise resolves only after success
    };

    request.onerror = () => {
      console.error('⚠️ Error retrieving data:', request.error);
      reject(request.error);
    };
  });
}


// Main Function: Load Cached or Fetch Fresh Data

 



async function loadProducts(url, uniqueKey) {
  $('#loadingScreen').show();

  const db = await openDB();
  
  // ✅ Open transaction and keep it active
  const productTx = db.transaction('products', 'readonly');
  const productStore = productTx.objectStore('products');

  const storedVersion = await new Promise((resolve, reject) => {
    const request = productStore.get('version');
    
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error);
  });

  //console.log('Stored Version:', storedVersion?.version);

  const jsonData = await fetchGzippedJson(url);
  //console.log('Fetched JSON Version:', jsonData.version);

  let data = await getCachedProducts();

  if (!data || data.length === 0 || (jsonData.version && storedVersion?.version !== jsonData.version)) {
   // console.log('🔄 Updating IndexedDB...');
    await storeProductsInIndexedDB(jsonData);
    data = jsonData.products;
  } else {
   // console.log('✅ IndexedDB is up-to-date. Using cached data.');
  }

  data = getUniqueRows(data, uniqueKey);
  buildTable(data);
}


function getUniqueRows(data, key) {
  if (!key) {
   // console.error('Error: getUniqueRows received undefined key!');
    return data; // Return unfiltered data instead of breaking
  }

  const seen = new Set();
  const filteredRows = data.filter((item) => {
    const value = item[key]; // Get the dynamic key value
    //console.log(`Checking item:`, item);
    //console.log(`Value for key "${key}":`, value);

    if (!value || seen.has(value)) {
      //console.log(`Skipping duplicate: ${value}`);
      return false;
    }

    seen.add(value);
    return true;
  });

  return filteredRows;
}

async function openDB() {
  //console.log('Attempting to open IndexedDB...');

  return new Promise((resolve, reject) => {
    const request = indexedDB.open('ProductCache', 1);

    request.onupgradeneeded = (event) => {
    //  console.log('Upgrading IndexedDB...');
      const db = event.target.result;
      db.createObjectStore('products', { keyPath: 'id' });
    };

    request.onsuccess = (event) => {
    //  console.log('IndexedDB opened successfully');
      const db = event.target.result;
     // console.log('DB Instance:', db);

      resolve(db);
    };

    request.onerror = (event) => {
      console.error('IndexedDB error:', event.target.error);
      reject(event.target.error);
    };

    request.onblocked = () => {
      console.warn('IndexedDB blocked! Close other tabs using this database.');
    };
  });
}

 

function filterData(data, filterKey, filterValue) {
  //console.log(`Filtering data by ${filterKey} = ${filterValue}`);

  const seen = new Set();
  const filteredRows = data.filter((item) => {
    // Check for duplicates based on genre
    if (seen.has(item.genre)) return false;
    seen.add(item.genre);

    // Apply dynamic filtering
    return item[filterKey]?.toLowerCase() === filterValue.toLowerCase();
  });

  return filteredRows;
}
